import { formatTwentyFourHourTime } from './formatTwentyFourHourTime'
import type { TimeOption } from './TimeOption'

export const buildTimeOptions = (
  stepMinutes = 30,
  labelFormatter: (value: string) => string = formatTwentyFourHourTime
): TimeOption[] => {
  const options: TimeOption[] = []

  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += stepMinutes) {
      const hourPadded = String(hour).padStart(2, '0')
      const minutePadded = String(minute).padStart(2, '0')
      const value = `${hourPadded}:${minutePadded}`

      options.push({
        value,
        label: labelFormatter(value)
      })
    }
  }

  return options
}
